import script from "./businessDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./businessDetail.vue?vue&type=script&setup=true&lang=js"

import "./businessDetail.vue?vue&type=style&index=0&id=64f9d521&lang=scss&scoped=true"

import exportComponent from "/Users/luoxuelin/Workspace/idea/wnzhfc/s-pages/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64f9d521"]])

export default __exports__